import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { size } from '@/helpers/lodash';
import { truthyOrZero } from '@/helpers/math';

const DEFAULT_COMPONENTS = {
  b: <b />,
  i: <i />
};

export const Translation = ({
  namespace,
  translationKeys,
  translationKey,
  tOptions,
  components,
  enableHtml,
  language,
  count
}) => {
  const namespaceToUse = namespace || 'common';
  const languageToUse = language || tOptions?.language;
  const countToUse = truthyOrZero(count) ? count : tOptions?.count;

  const translationKeyToUse = useMemo(() => (
    (Array.isArray(translationKeys) && size(translationKeys))
      ? ((enableHtml ? (translationKeys || [])[0] : translationKeys) || translationKey)
      : translationKey
  ), [translationKeys, translationKey, enableHtml]);

  const componentsToUse = useMemo(() => {
    const isArray = Array.isArray(components);

    if (!enableHtml) {
      return [];
    }

    return isArray
      ? (components || [])
      : ({
        ...DEFAULT_COMPONENTS,
        ...components || {}
      });
  }, [components, enableHtml]);

  const options = useMemo(() => ({
    ...tOptions,
    ...(languageToUse ? { lng: languageToUse } : {}),
    ...((!enableHtml && truthyOrZero(countToUse)) ? { count: countToUse } : {})
  }), [tOptions, languageToUse, countToUse, enableHtml]);

  if (enableHtml) {
    return (
      <>
        {translationKeyToUse}
        {componentsToUse.map((Component, index) => (
          <Component key={index} />
        ))}
        {truthyOrZero(countToUse) && countToUse}
      </>
    );
  }

  return translationKeyToUse;
};

Translation.propTypes = {
  namespace: PropTypes.string,
  translationKey: PropTypes.string,
  translationKeys: PropTypes.array,
  tOptions: PropTypes.object,
  components: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  enableHtml: PropTypes.bool,
  language: PropTypes.string,
  count: PropTypes.number
};

Translation.defaultProps = {
  namespace: 'common',
  translationKey: undefined,
  translationKeys: undefined,
  tOptions: {},
  components: undefined,
  enableHtml: false,
  language: undefined,
  count: undefined
};

export default Translation;
